import i18n from "i18n";
import Routes from "routing/Routes";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import AppConfig from "util/AppConfig";
import { COLLECTOR_PERMISSIONS } from "components/collectors/Permissions";
import useCanAccessDeployment from "components/collectors/hooks/useCanAccessDeployment";
export const PAGE_NAV_TITLE = "Collectors";
const bindings = AppConfig.isFeatureEnabled("collectors") ? {
  pageNavigation: [
    {
      description: PAGE_NAV_TITLE,
      titleKey: "navigation:system.collectors",
      children: [
        {
          description: "Overview",
          titleKey: "collectors:navigation.overview",
          path: Routes.SYSTEM.COLLECTORS.OVERVIEW,
          exactPathMatch: true
        },
        { description: "Fleets", titleKey: "collectors:navigation.fleets", path: Routes.SYSTEM.COLLECTORS.FLEETS },
        {
          description: "Instances",
          titleKey: "collectors:navigation.instances",
          path: Routes.SYSTEM.COLLECTORS.INSTANCES
        },
        {
          description: "Deployment",
          titleKey: "collectors:navigation.deployment",
          path: Routes.SYSTEM.COLLECTORS.DEPLOYMENT,
          useCondition: useCanAccessDeployment
        },
        {
          description: "Settings",
          titleKey: "collectors:navigation.settings",
          path: Routes.SYSTEM.COLLECTORS.SETTINGS,
          permissions: [COLLECTOR_PERMISSIONS.CONFIGURATION_READ]
        }
      ]
    }
  ],
  entityCreators: [
    {
      id: "Fleet",
      // Read lazily, so the title is translated when it is displayed and not when the module loads.
      get title() {
        return i18n.t("entity_creators.fleet", { ns: "common" });
      },
      path: Routes.SYSTEM.COLLECTORS.FLEETS_NEW,
      telemetryEvent: {
        type: TELEMETRY_EVENT_TYPE.COLLECTORS.FLEET.CREATE_OPENED,
        section: "collectors",
        actionValue: "create-fleet-button"
      },
      permissions: COLLECTOR_PERMISSIONS.FLEET_CREATE
    }
  ]
} : {};
export default bindings;
